/**
 * Beauty Solutions Cross-Store Redirect Handler
 * Intercepts Shop Now button clicks + add-to-cart forms
 * Redirects to Beauty Solutions store
 */
(function () {
  'use strict';

  if (!window.BeautySolutionsConfig) {
    console.warn('[BeautySolutions] Config not loaded');
    return;
  }

  const CFG = window.BeautySolutionsConfig;
  if (!CFG.enabled) return;

  function buildProductUrl(handle, customUrl) {
    const baseUrl = customUrl || (CFG.storeURL + '/products/' + handle);
    const utm = CFG.utmParams || {};
    const separator = baseUrl.indexOf('?') !== -1 ? '&' : '?';
    const utmString = Object.keys(utm)
      .map(k => 'utm_' + k + '=' + encodeURIComponent(utm[k]))
      .join('&');
    return baseUrl + (utmString ? separator + utmString : '');
  }

  function buildStoreUrl() {
    const baseUrl = CFG.cartRedirectURL || CFG.storeURL;
    const utm = CFG.utmParams || {};
    const separator = baseUrl.indexOf('?') !== -1 ? '&' : '?';
    const utmString = Object.keys(utm)
      .map(k => 'utm_' + k + '=' + encodeURIComponent(utm[k]))
      .join('&');
    return baseUrl + (utmString ? separator + utmString : '');
  }

  function trackRedirect(handle) {
    if (typeof gtag === 'function') {
      gtag('event', 'shop_now_click', {
        product_handle: handle,
        destination: CFG.storeURL,
        event_category: 'cross_store_redirect'
      });
    }
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'ShopNowRedirect', {
        product_handle: handle,
        destination: CFG.storeURL
      });
    }
  }

  function getProductHandleFromPage() {
    const match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  function redirectToProduct(handle, customUrl) {
    trackRedirect(handle);
    setTimeout(function () {
      window.location.href = buildProductUrl(handle, customUrl);
    }, 140);
  }

  // ─────────────────────────────
  // Handle Shop Now button clicks
  // ─────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-shop-now-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    const customUrl = btn.getAttribute('data-product-url');
    if (!handle && !customUrl) return;

    btn.classList.add('shop-now-btn--loading');
    btn.setAttribute('aria-busy', 'true');
    const textEl = btn.querySelector('.shop-now-btn__text');
    if (textEl) textEl.textContent = CFG.loadingText || 'Redirecting...';

    redirectToProduct(handle, customUrl);
  });

  // ─────────────────────────────
  // Intercept ANY add-to-cart form
  // (Safety net — catches all paths)
  // ─────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('[action*="/cart/add"]') || form.getAttribute('data-type') === 'add-to-cart-form') {
      e.preventDefault();
      e.stopPropagation();
      const handle = getProductHandleFromPage();
      if (handle) {
        redirectToProduct(handle);
      } else {
        window.location.href = buildStoreUrl();
      }
    }
  }, true);

  // ─────────────────────────────
  // Block native add-to-cart button clicks (backup safety)
  // ─────────────────────────────
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('add-to-cart-component button, .add-to-cart-button, .sticky-add-to-cart__button');
    if (addBtn && !addBtn.closest('[data-shop-now-btn]')) {
      // Only intercept if it's truly an add-to-cart button (not our shop-now button)
      const isAddToCart = addBtn.name === 'add' ||
                          addBtn.hasAttribute('data-add-to-cart') ||
                          addBtn.classList.contains('add-to-cart-button');
      if (isAddToCart) {
        e.preventDefault();
        e.stopPropagation();
        const handle = getProductHandleFromPage();
        if (handle) redirectToProduct(handle);
        else window.location.href = buildStoreUrl();
      }
    }
  }, true);

  // ─────────────────────────────
  // Cart page redirect
  // ─────────────────────────────
  if (window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart?')) {
    window.location.replace(buildStoreUrl());
  }

  // ─────────────────────────────
  // Block /cart/add.js XHR calls (block JavaScript-based add-to-cart)
  // ─────────────────────────────
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (url, opts) {
      const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1) {
        console.info('[BeautySolutions] Blocked cart/add — redirecting instead');
        const handle = getProductHandleFromPage();
        if (handle) redirectToProduct(handle);
        else window.location.href = buildStoreUrl();
        return Promise.reject(new Error('Cart add blocked — redirecting to Beauty Solutions'));
      }
      return origFetch.apply(this, arguments);
    };
  }

  console.info('[BeautySolutions] Redirect active. Target:', CFG.storeURL);
})();
